import CheckIcon from 'vux/src/components/check-icon/index.vue'

export default {
name: 'logoutCannot',
components: {
CheckIcon
},
data () {
return {
list: []
}
},
methods: {
backPersonalData () {
this.$request.post('/user/delLogoutExamine',{

}).then(data => {
if(data.code == 0){
this.$router.push({
path: '/personalData'
})
}else{
this.$vux.toast.show({
type: 'cancel',
text: data.msg
})
}
}).catch(e => {
console.log(e)
})
},
getList () {
this.$request.post('/user/checkLogoutUser',{

}).then(data => {
console.log(data)
if(data.code == 0){
this.list = data.obj.msg
}else{
this.$vux.toast.show({
type: 'warn',
text: data.msg
})
}
}).catch(e => {
console.log(e)
})
}
},
created () {

},
mounted() {
this.getList()
}
}



// WEBPACK FOOTER //
// ./src/views/logoutCannot/script.js